import {
  TooltipProvider,
  TooltipRoot,
  TooltipTrigger,
  TooltipContent,
} from "@repo/ui/components/Base/TooltipBase";
import type { PropsWithChildren } from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { cn } from "@repo/shared/utils";

export type TooltipProps = PropsWithChildren & {
  label?: React.ReactNode;
  asChild?: boolean;
  tooltipTriggerProps?: TooltipPrimitive.TooltipTriggerProps;
  delayDuration?: number;
  disableHoverableContent?: boolean;
  className?: string;
};
export const Tooltip = ({
  label,
  children,
  asChild,
  tooltipTriggerProps,
  delayDuration,
  disableHoverableContent,
  className,
}: TooltipProps) => {
  return (
    <TooltipProvider
      disableHoverableContent={disableHoverableContent}
      delayDuration={delayDuration ?? 700}
    >
      <TooltipRoot>
        <TooltipTrigger
          asChild={asChild}
          type="button"
          {...tooltipTriggerProps}
        >
          {children}
        </TooltipTrigger>
        <TooltipContent className={cn("text-center", className)}>
          {label}
        </TooltipContent>
      </TooltipRoot>
    </TooltipProvider>
  );
};
